import Module from './Module';
import { app } from '../utils/store';

export default class AsyncLoad extends Module {
	constructor({ element }) {
		super({ element })

		this.createObserver()
	}

	fetchImageURL() {
		if (app.webp === true) {
			const webpURL = app.device.mobile 
				? this.element.getAttribute('data-mobile-webp') 
				: this.element.getAttribute('data-webp')
			
			if (webpURL) {
				// Usa un'immagine temporanea per verificare se il WebP esiste
				const testImage = new Image()
				testImage.onload = () => {
					// WebP esiste, usalo
					this.element.src = webpURL
				}
				testImage.onerror = () => {
					// WebP non disponibile, usa il fallback
					this.element.src = app.device.mobile 
						? this.element.getAttribute('data-mobile-src') 
						: this.element.getAttribute('data-src')
				}
				testImage.src = webpURL
				return
			}
		}
		
		// Fallback a formato normale
		this.element.src = app.device.mobile 
			? this.element.getAttribute('data-mobile-src') 
			: this.element.getAttribute('data-src')
	}

	createObserver(element) {
		this.observer = new window.IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				this.style = this.element.getAttribute('style')
				
				if(app.device.mobile){ this.element.setAttribute('style', this.element.getAttribute('data-mobile-style')) }
				else { this.element.setAttribute('style', this.style) }

				if (entry.isIntersecting && !this.element.hasAttribute('loaded')) {
					this.fetchImageURL()
					this.element.onload = () => { 
						this.element.setAttribute('loaded', ''); 
						this.observer.unobserve(this.element);
					}
				}
			})
		}, {
			// root: window,
			rootMargin: '10%',
		})

		this.observer.observe(this.element)
	}
}
